/**
 * alert Group
 * @param fb : FormBuilder
 */


export function alert2Group (fb: any):any {
    return fb.group({
        reference: fb.control(''),
        end: fb.group({
            min: fb.control(''),
            max: fb.control('')
        }),
        scope: fb.group({
            reference: fb.control(''),
            target: fb.control([])
        }),
        status: fb.control([])
    });
}

// this.fb.group({ ... },  })